import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/ai/AGoogleAdsInstructions/list", {
        params: {
            ...params
        }
    } )
}
function EDIT_DATA(params) {
    return  axios.get("/ai/AGoogleAdsInstructions/info", {
        params:{
            ...params
        }
    })
}
function SUBMIT_ADD(params) {
    return  axios.post("/ai/AGoogleAdsInstructions/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/ai/AGoogleAdsInstructions/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/ai/AGoogleAdsInstructions/editStatus",{...params} )
}

export default {
    GET_LIST,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    EDIT_DATA
}
